module.exports = __webpack_public_path__ + "static/img/p06.e061027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comic/001/p06.jpg
// module id = 119
// module chunks = 0